var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyledcomponents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 128 128",
    height: "32px",
    width: "32px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.027,
    stopColor: "#cc7f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.157,
    stopColor: "#ffc22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffd468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4f95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#d26aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#dc81bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#d76cad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#d26cab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#ca629d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c96499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94481",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.694,
    stopColor: "#b94481",
    stopOpacity: 0.186
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b94481",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644,
    stopColor: "#b94481",
    stopOpacity: 0.186
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b94481"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 75.533,
    x2: 84.143,
    y1: 24.539,
    y2: 26.989,
    gradientTransform: "translate(-138.07 -65.083) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.021,
    stopColor: "#a65486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.095,
    stopColor: "#db77b4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.146,
    stopColor: "#f188c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    stopColor: "#ffaddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.372,
    stopColor: "#ffaddf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576,
    stopColor: "#ee84c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#da6fb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a63d7b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 75.683,
    x2: 81.533,
    y1: 32.735,
    y2: 34.22,
    gradientTransform: "translate(-138.02 -65.654) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#974377"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#cc76ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#f5a3d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#fca6da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#e980c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#a34d81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 84.026,
    x2: 80.731,
    y1: 40.955,
    y2: 45.932,
    gradientTransform: "translate(-162.274 -67.103) scale(3.17893)",
    gradientUnits: "userSpaceOnUse",
    spreadMethod: "reflect"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc83b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.159,
    stopColor: "#de77b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#dd74b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.797,
    stopColor: "#d65fa3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c95195",
    stopOpacity: 0.992
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "l",
    x1: 78.017,
    x2: 81.33,
    y1: 49.373,
    y2: 53.353,
    gradientTransform: "translate(-168.668 -75.437) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 65.654,
    x2: 68.885,
    y1: 38.931,
    y2: 42.708,
    gradientTransform: "translate(-137.907 -65.725) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf4f95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.284,
    stopColor: "#d26aaa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.588,
    stopColor: "#dc81ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711,
    stopColor: "#d76cad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.825,
    stopColor: "#d26cab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.957,
    stopColor: "#ca629d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c96499"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "f",
    x1: 56.495,
    x2: 60.682,
    y1: 36.149,
    y2: 41.138,
    gradientTransform: "translate(-137.907 -65.725) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 48.116,
    x2: 52.831,
    y1: 43.62,
    y2: 49.525,
    gradientTransform: "translate(-137.907 -65.725) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.085,
    stopColor: "#cc7f12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#ffc22f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ffd468"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd255"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "k",
    x1: 61.027,
    x2: 67.311,
    y1: 52.984,
    y2: 60.788,
    gradientTransform: "translate(-137.907 -65.725) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#b",
    id: "h",
    x1: 54.432,
    x2: 60.703,
    y1: 47.454,
    y2: 54.998,
    gradientTransform: "translate(-137.907 -65.725) scale(3.17893)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#c",
    id: "o",
    cx: 82.591,
    cy: 43.432,
    r: 3.168,
    gradientTransform: "matrix(1.97592 .73804 -1.60788 4.30471 7.727 -177.69)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#c",
    id: "m",
    cx: 79.826,
    cy: 51.54,
    r: 4.893,
    gradientTransform: "matrix(3.82361 -3.26243 1.22831 1.4396 -283.113 275.387)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#d",
    id: "j",
    cx: 67.057,
    cy: 40.547,
    r: 5.605,
    gradientTransform: "matrix(1.79287 1.6183 -2.85108 3.15866 70.64 -173.422)",
    gradientUnits: "userSpaceOnUse"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    xlinkHref: "#d",
    id: "g",
    cx: 59.193,
    cy: 38.098,
    r: 5.501,
    gradientTransform: "matrix(1.62883 1.58368 -2.9995 3.08503 68.5 -155.597)",
    gradientUnits: "userSpaceOnUse"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M0 117.37V87.272l34.796-28.068c7.746-6.248 15.304-8.216 23.363-3.753 3.144 1.74 4.263 7.499 2.245 11.936z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M32.875 61.271c6.497-7.899 15.238-14.989 25.507-21.195 6.803-4.11 12.273 4.327 6.394 12.786-6.09 8.023-14.38 14.928-21.136 19.664-4.536 3.179-13.723-7.657-10.765-11.255z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M32.875 61.271c6.497-7.899 15.238-14.989 25.507-21.195 6.803-4.11 12.273 4.327 6.394 12.786-6.09 8.023-14.38 14.928-21.136 19.664-4.536 3.179-13.723-7.657-10.765-11.255z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M0 117.37v10.013h29.427l53.924-43.814c5.43-5.2 4.814-13.84 2.121-18.566-5.646-9.919-17.22-.971-25.068 2.384z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M58.733 68.07c5.213-5.715 28.256-25.774 32.512-21.452 3.87 3.932 1.747 12.598-7.48 22.78-7.309 8.061-16.517 13.489-21.305 9.695-3.974-3.144-6.768-7.69-3.727-11.024z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M58.733 68.07c5.213-5.715 28.256-25.774 32.512-21.452 3.87 3.932 1.747 12.598-7.48 22.78-7.309 8.061-16.517 13.489-21.305 9.695-3.974-3.144-6.768-7.69-3.727-11.024z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M29.427 127.383h45.216c12.078-11.678 27.234-25.566 20.927-36.44-3.716-6.399-8.02-7.567-12.219-7.375z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M100.788 73.866c-1.308-7.854-28.891 15.579-30.554 18.676-1.608 2.994 2.511 14.462 9.037 11.532 8.355-3.948 23.683-17.206 21.517-30.208z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M100.788 73.866c-1.308-7.854-28.891 15.579-30.554 18.676-1.608 2.994 2.511 14.462 9.037 11.532 8.355-3.948 23.683-17.206 21.517-30.208z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M102.554 57.16c-9.007 6.778-3.168 17.825-13.588 23.862 13.611 2.815 22-16.195 19.791-23.168z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M102.554 57.16c-9.007 6.778-3.168 17.825-13.588 23.862 13.611 2.815 22-16.195 19.791-23.168z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "m120.353 20.507-11.58 38.1c-2.196.882-4.75.275-6.198-1.508l9.171-39.294z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M128 .617v23.9c-7.962 3.174-28.11-4.765-25.764-12.255L105.881.617z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyledcomponents);
export default __webpack_public_path__ + "static/media/styledcomponents.7dd24e0034a63b0e89ae177ee1c06f3a.svg";
export { ForwardRef as ReactComponent };